import { useState, useEffect, useContext } from "react";
import saveIcon from "../../assets/save-icon.svg";
import editIcon from "../../assets/edit-latest-icon.svg";
import { CaseStageContext } from "../../dashboard/cases/contexts/CaseContexts";
import { PatientServices } from "../../services/PatientServices";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
const PersonalHistoryForm = ({ data, caseStage, saveAll }) => {
  const { patientDetails } = useContext(CaseStageContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    diet: "NORMAL",
    nutrition: "NORMAL",
    appetite: "NORMAL",
    bowels: "NORMAL",
    knownAllergies: "YES",
    habitsAddictions: "YES",
    allergyDetails: null,
    addictionDetails: null,
  });
  const location = useLocation();
  const dietOptions = ["SPECIAL", "NORMAL"];
  const nutritionOptions = ["MALNOURISHED", "NORMAL"];
  const appetiteOptions = ["NORMAL", "LOW", "EXCESSIVE"];
  const bowelOptions = ["NORMAL", "CONSTIPATION", "LOOSE"];
  const addictionOptions = ["ALCOHOL", "SMOKING", "DRUGS", "OTHERS"];

  const handleUpdate = async () => {
    setIsSubmitting(true);
    const data = {
      ...formData,
      allergies: formData?.knownAllergies,
      addictions: formData?.habitsAddictions,
    };
    try {
      await PatientServices.updatePersonalHistory(
        data,
        patientDetails?.personalhistories[0]?.id,
      );
      // setUpdated(!updated);
      toast.success("Personal History Data Saved");
      setIsEditMode(false);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setIsSubmitting(false);
  };

  useEffect(() => {
    if (!patientDetails) return;
    const data = patientDetails?.personalhistories[0];
    setFormData({
      diet: data?.diet !== "None" && data?.diet ? data.diet : "NORMAL",
      nutrition:
        data?.nutrition !== "None" && data?.nutrition
          ? data.nutrition
          : "NORMAL",
      appetite:
        data?.appetite !== "None" && data?.appetite ? data.appetite : "NORMAL",
      bowels: data?.bowels !== "None" && data?.bowels ? data.bowels : "NORMAL",
      knownAllergies: data?.allergies?.toLowerCase() === "yes" ? "YES" : "NO",
      habitsAddictions:
        data?.addictions?.toLowerCase() === "yes" ? "YES" : "NO",
      allergyDetails: data?.allergyDetails || "",
      addictionDetails: data?.addictionDetails || "",
    });
  }, [patientDetails]);
  useEffect(() => {
    if (saveAll && isEditMode) {
      handleUpdate();
    }
  }, [saveAll]);
  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />{" "}
      <div className="grid grid-cols-3 2xl:grid-cols-4 gap-[6px] 2xl:gap-[4px] 3xl:gap-3 pt-[30px]">
        {/* Diet */}
        <div className="relative w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
          <select
            disabled={!isEditMode}
            value={formData.diet}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                diet: e.target.value,
              }))
            }
            className="absolute inset-0 w-full h-full pl-[32px] pr-[50px] bg-transparent border-none outline-none appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
          >
            <option value="" disabled hidden>
              Diet*
            </option>

            {dietOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          {formData.diet && (
            <span className="absolute right-[45px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
              Diet
            </span>
          )}

          <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M7 10.5L14 17.5L21 10.5"
                stroke="#5AC69F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Nutrition */}
        <div className="relative w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
          <select
            disabled={!isEditMode}
            value={formData.nutrition}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                nutrition: e.target.value,
              }))
            }
            className="absolute inset-0 w-full h-full pl-[32px] pr-[50px] bg-transparent border-none outline-none appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
          >
            <option value="" disabled hidden>
              Nutrition*
            </option>

            {nutritionOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          {formData.nutrition && (
            <span className="absolute right-[45px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
              Nutrition
            </span>
          )}

          <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M7 10.5L14 17.5L21 10.5"
                stroke="#5AC69F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Appetite */}
        <div className="relative w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
          <select
            disabled={!isEditMode}
            value={formData.appetite}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                appetite: e.target.value,
              }))
            }
            className="absolute inset-0 w-full h-full pl-[32px] pr-[50px] bg-transparent border-none outline-none appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
          >
            <option value="" disabled hidden>
              Appetite*
            </option>

            {appetiteOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          {formData.appetite && (
            <span className="absolute right-[45px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
              Appetite
            </span>
          )}

          <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M7 10.5L14 17.5L21 10.5"
                stroke="#5AC69F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Bowels */}
        <div className="relative w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
          <select
            disabled={!isEditMode}
            value={formData.bowels}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                bowels: e.target.value,
              }))
            }
            className="absolute inset-0 w-full h-full pl-[32px] pr-[50px] bg-transparent border-none outline-none appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
          >
            <option value="" disabled hidden>
              Bowels*
            </option>

            {bowelOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          {formData.bowels && (
            <span className="absolute right-[45px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
              Bowels
            </span>
          )}

          <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M7 10.5L14 17.5L21 10.5"
                stroke="#5AC69F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Known Allergies */}
        <div className="w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] pl-[14px] pr-[4px] flex items-center">
          <span className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#1A1A1A] whitespace-nowrap">
            Known Allergies
          </span>

          <div className="ml-auto flex items-center gap-[2px]">
            <button
              disabled={!isEditMode}
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  knownAllergies: "YES",
                }))
              }
              className={`w-[66px] h-[41px] rounded-[100px] border border-none flex justify-center items-center font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] ${
                formData.knownAllergies === "YES"
                  ? "bg-[#5AC69F] text-white"
                  : "bg-[#F5F5F5] text-[#000000]"
              }`}
            >
              Yes
            </button>

            <button
              disabled={!isEditMode}
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  knownAllergies: "NO",
                }))
              }
              className={`w-[66px] h-[41px] rounded-[100px] border border-none flex justify-center items-center font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] ${
                formData.knownAllergies === "NO"
                  ? "bg-[#FF4343] text-white"
                  : "bg-[#F5F5F5] text-[#000000]"
              }`}
            >
              No
            </button>
          </div>
        </div>

        {/* Allergic to penicillin */}
        {formData.knownAllergies === "YES" && (
          <div className="w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent px-[32px] flex items-center">
            <input
              disabled={!isEditMode}
              type="text"
              placeholder="Allergic to penicillin"
              value={formData.allergyDetails}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  allergyDetails: e.target.value,
                }))
              }
              className="w-full bg-transparent border-none outline-none focus:outline-none focus:ring-0 focus:border-none shadow-none font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#1A1A1A] placeholder:text-[#8B8B8B]"
            />
          </div>
        )}

        {formData.knownAllergies === "YES" &&
          formData.habitsAddictions === "YES" && (
            <div className="hidden xl:block xl:col-span-3 2xl:col-span-4 3xl:hidden h-0"></div>
          )}

        {/* Habits Addictions */}
        <div className="w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] pl-[14px] pr-[4px] flex items-center">
          <span className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#1A1A1A] whitespace-nowrap">
            Habits Addictions
          </span>

          <div className="ml-auto flex items-center gap-[2px]">
            <button
              disabled={!isEditMode}
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  habitsAddictions: "YES",
                }))
              }
              className={`w-[66px] h-[41px] rounded-[100px] border border-none flex justify-center items-center font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] ${
                formData.habitsAddictions === "YES"
                  ? "bg-[#5AC69F] text-white"
                  : "bg-[#F5F5F5] text-[#000000]"
              }`}
            >
              Yes
            </button>

            <button
              disabled={!isEditMode}
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  habitsAddictions: "NO",
                }))
              }
              className={`w-[66px] h-[41px] rounded-[100px] border border-none flex justify-center items-center font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] ${
                formData.habitsAddictions === "NO"
                  ? "bg-[#FF4343] text-white"
                  : "bg-[#F5F5F5] text-[#000000]"
              }`}
            >
              No
            </button>
          </div>
        </div>

        {/* Select */}
        {formData.habitsAddictions === "YES" && (
          <div className="relative w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
            <select
              disabled={!isEditMode}
              value={formData.addictionDetails}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  addictionDetails: e.target.value,
                }))
              }
              className="absolute inset-0 w-full h-full pl-[32px] pr-[50px] bg-transparent border-none outline-none appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
            >
              <option value="" disabled hidden>
                Select
              </option>

              {addictionOptions.map((option) => (
                <option key={option} value={option} className="pl-4">
                  {option}
                </option>
              ))}
            </select>

            <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path
                  d="M7 10.5L14 17.5L21 10.5"
                  stroke="#5AC69F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        )}
      </div>
      {!location?.pathname?.toLowerCase()?.includes("editcases") && (
        <div>
          {isEditMode ? (
            <div className="flex justify-end mt-[12px]">
              <button
                className="w-[170px] h-[74px] xl:w-[94.97px] xl:h-[40.97px] 2xl:w-[94.97px] 2xl:h-[40.97px] border border-none rounded-full bg-black flex justify-center items-center gap-[8px] font-lufga text-[14px] text-[#68FF9F] font-normal"
                onClick={handleUpdate}
                disabled={isSubmitting}
              >
                SAVE
                <img src={saveIcon} alt="save" className="pl-[16px]" />
              </button>
            </div>
          ) : (
            <div className="flex justify-end items-center gap-[10px] mt-[12px]">
              <button className="w-[170px] h-[74px] xl:w-[101px] xl:h-[42px] 2xl:w-[101px] 2xl:h-[42px] rounded-full border border-none bg-[#5AC69F] flex justify-center items-center gap-[10px] font-lufga text-[14px] text-white font-normal">
                SAVED
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 13L9 17L19 7"
                    stroke="white"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              <button
                onClick={() => setIsEditMode(true)}
                className="w-[42px] h-[42px] rounded-full border border-solid border-[#5AC69F] flex justify-center items-center bg-transparent"
              >
                <img src={editIcon} alt="edit icon" width={9} height={18} />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PersonalHistoryForm;
